import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type DeleteProgramMemberBody = {
  data: Array<{
    entity_ids: string[];
    entity_type: 'Program';
    roles: string[];
    user_id: string;
  }>;
};

type DeleteProgramMemberRouteParams = {
  programId: string;
  userId: string;
};

export const deleteProgramMember = async ({
  body,
}: BodyRouteParamsRequest<DeleteProgramMemberBody, DeleteProgramMemberRouteParams>) =>
  apiClient.patch<unknown, ApiClientResponse<unknown>>(routes.community.changeRole, body);
